import { createContext, useContext } from "react";

export const BizTripBookingContext = createContext({
  bizData: {},
  activeTripType: "",
  setBizData: () => {},
  setActiveTripType: () => {},
  userData: {},
  setUserData: () => {},
});
export const useBizTripBookingContext = () => useContext(BizTripBookingContext);
